import Midi from '@tonaljs/midi'
import { ScaleLib } from '@tunasong/music-lib'
import type { NoteName, Scale } from '@tunasong/schemas'
import { NoteLabel } from './label.js'
import type { NoteLabelProps, NoteLabelType } from './keyboard.js'

/** HOC for a scale */
export const NoteLabelForScale =
  (
    scale?: Scale | null,
    label: NoteLabelType = 'note-scale',
    showLabelOnActiveOnly = false,
    showLabelInScaleOnly = false
  ) =>
  (props: NoteLabelProps) => {
    const { midiNumber, octave, isActive } = props
    const noteName = Midi.midiToNoteName(midiNumber, { pitchClass: true }) as NoteName

    const note = scale ? ScaleLib.getScaleNoteName(scale, noteName) : noteName
    const inScale = scale ? ScaleLib.noteInScale(scale, note) : false

    if (!isActive && showLabelOnActiveOnly) {
      return null
    }
    if (showLabelInScaleOnly && !inScale) {
      return null
    }
    /** Is pitchName in the scale? */
    return <NoteLabel {...props} note={note} scale={scale} octave={octave} label={label} />
  }
